export { default as GlobalLoader } from './global';
export { default as SmallLoader } from './small';
